import React, { useReducer, createContext, useEffect } from "react"
import { useTranslation } from "react-i18next"

const initialState = localStorage.getItem("i18nextLng") || "en"

const langReducer = (_, lang) => (lang === "ind" ? "ind" : "en")

export const LangContext = createContext({})

export const LangProvider = ({ children }) => {
  const [lang, dispatch] = useReducer(langReducer, initialState)
  const { i18n } = useTranslation()

  useEffect(() => {
    i18n.changeLanguage(lang)
    // eslint-disable-next-line
  }, [lang])

  return (
    <LangContext.Provider value={{ lang, dispatch }}>
      {children}
    </LangContext.Provider>
  )
}
